import { Component, OnInit, OnDestroy } from '@angular/core';
import { CustomOktaAuthService } from '../oktaauth.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
    selector: 'app-callback',
    templateUrl: './callback.component.html',
    styleUrls: ['./callback.component.scss'],
    standalone: false
})
export class CallbackComponent implements OnInit, OnDestroy {
  private IAMSubscription: Subscription;

  constructor(private okta: CustomOktaAuthService, private router: Router) { }

  async ngOnInit() {
    // Handles the response from Okta and parses tokens
    const isAuthenticated = await this.okta.handleAuthentication();
    if (!isAuthenticated) {
      this.okta.logout();
      return;
    }
    this.handleAuthorization();
  }

  handleAuthorization() {
    this.IAMSubscription = this.okta.getIAMRoles().subscribe(members => {
      this.okta.handAuthResponse(members);
    });
  }

  ngOnDestroy(): void {
    this.IAMSubscription.unsubscribe();
  }
}
